import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

import {
  ForgotPasswordFormValues,
  forgotPasswordInitialValues,
  forgotPasswordValidationSchema,
} from '@/pages/ForgotPassword/validation'
import { Form, Formik } from 'formik'
import { forgotPassword } from '@/redux/asyncThunks/user'
import { toast } from 'sonner'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '@/redux/hooks'
import ROUTES from '@/routes/routes'

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const handleSubmit = async (values: ForgotPasswordFormValues) => {
    try {
      const resultAction = await dispatch(
        forgotPassword({
          email: values.email,
        })
      )
      if (forgotPassword.rejected.match(resultAction)) {
        toast.error('Something went wrong')
      } else {
        toast.success(resultAction.payload.message)
        navigate(ROUTES.LOGIN)
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <div className='flex h-screen w-screen flex-col md:flex-row'>
      <div className='relative hidden flex-1 md:block'>
        <img
          src='/images/auth-background.svg'
          alt='Auth background'
          className='absolute w-1/2 object-cover md:h-full md:w-5/6'
        />
        <div className='flex h-full items-center justify-center'>
          <img
            src='/images/auth-avatar.svg'
            alt='Auth Avatar'
            className='absolute z-10 object-contain md:h-full md:w-auto'
          />
        </div>
      </div>
      <div className='flex flex-1 flex-col items-center justify-center'>
        <div className='flex justify-center'>
          <img
            src='/images/oge.svg'
            alt='Huble logo'
            className='w-1/2 object-contain md:w-full'
          />
        </div>
        <div className='flex w-3/4 flex-col items-center md:w-full'>
          <Card className='w-full max-w-md border-none shadow-none'>
            <CardHeader className='space-y-1 flex flex-col items-center'>
              <CardTitle className='text-4xl font-bold leading-[50px]'>
                Welcome to OGE
              </CardTitle>
              <CardDescription className='text-base text-black font-normal'>
                Don’t worry, happens to all of us. Enter your email below to
                recover your password.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Formik
                initialValues={forgotPasswordInitialValues}
                validationSchema={forgotPasswordValidationSchema}
                onSubmit={handleSubmit}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  isSubmitting,
                }) => (
                  <Form className='space-y-4'>
                    <div className='space-y-2'>
                      <Label
                        className={`text-base font-normal ${
                          touched.email && errors.email
                            ? 'text-red-500'
                            : 'text-gray-700'
                        }`}
                        htmlFor='email'
                      >
                        Email
                      </Label>
                      <Input
                        className={`h-10 placeholder:text-base placeholder:text-[#99A2B0] bg-[#FAFCFF] ${
                          touched.email && errors.email
                            ? 'border-red-500'
                            : 'border-gray-300'
                        }`}
                        id='email'
                        name='email'
                        type='email'
                        placeholder='Enter an Email'
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.email && errors.email && (
                        <div className='text-red-500 text-sm flex gap-2'>
                          <img src='/icons/alert-circle.svg' alt='Warning' />
                          {errors.email}
                        </div>
                      )}
                    </div>
                    <Button
                      type='submit'
                      disabled={isSubmitting}
                      className='w-full h-[38px] text-base font-normal bg-dark-blue hover:bg-dark-blue-hovered'
                    >
                      Submit
                    </Button>
                  </Form>
                )}
              </Formik>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword
